import React from 'react'

interface IconProps {
  className?: string
}

const PawPrint = ({ className }: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M9.86449 4.68744C10.2828 6.17173 9.92628 7.571 9.06827 7.81278C8.21026 8.05457 7.17562 7.04732 6.75735 5.56303C6.33908 4.07873 6.69556 2.67947 7.55358 2.43769C8.41159 2.1959 9.44622 3.20315 9.86449 4.68744Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8561 5.55229C16.4447 7.03849 15.4147 8.05048 14.5556 7.81264C13.6965 7.57479 13.3336 6.17718 13.745 4.69099C14.1565 3.20479 15.1864 2.1928 16.0456 2.43064C16.9047 2.66848 17.2676 4.06609 16.8561 5.55229Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5891 10.8721C21.2638 12.0473 20.3982 12.8334 19.6559 12.6279C18.9136 12.4224 18.5755 11.3031 18.9009 10.1279C19.2263 8.95268 20.0918 8.16659 20.8341 8.3721C21.5764 8.57761 21.9145 9.6969 21.5891 10.8721Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.58913 10.8721C2.91448 12.0473 3.78001 12.8334 4.52234 12.6279C5.26466 12.4224 5.60269 11.3031 5.27734 10.1279C4.95199 8.95268 4.08646 8.16659 3.34414 8.3721C2.60181 8.57761 2.26378 9.6969 2.58913 10.8721Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19.5C13.6868 19.5 17.5 22 19 20C20.29 18.2799 18.8668 16.6597 17.5 15C16.1331 13.3403 14 11.5 12 11.5C9.8499 11.5 7.86685 13.3401 6.50001 14.9998L6.48943 15.0127C5.1268 16.6673 3.89662 18.1611 5 20C6.50004 22.5 10.3132 19.5 12 19.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PawPrint
